import { styled } from 'styled-components'
import { PresentIcon, TagIcon } from '../../../icons'

export const TagCheckoutIcon = styled(TagIcon)`
  margin-bottom: 2px;
  margin-left: -6px;
`

export const PresentCheckoutIcon = styled(PresentIcon)`
  margin-bottom: 2px;
  margin-left: -6px;
`

export const FinalCouponSeparator = styled.div`
  width: 100%;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.gray3}`};
  margin: ${({ $woodPricingEnabled }) =>
    $woodPricingEnabled ? '0 0 16px' : '0 0 25px'};
`
